<template>
  <scoped>
    <VerticalNavigator
      :links="[{
        title: 'Create',
        routeName: 'create_trademark'
      }]"
    >
      <Breadcrumb
        :links="[{
          title: 'RutSolve',
          routeName: 'index'
        }]"
        title="Trademarks"
      />
      <h1>
        Trademarks
      </h1>
      <div class="grid">
        <div class="list">
          <TrademarkSelector v-model:value="selectedTrademark" />
        </div>
        <div
          v-if="selectedTrademark"
          class="summary"
        >
          <TrademarkSummary
            :key="selectedTrademark.id"
            :trademarkID="selectedTrademark.id"
          />
          <Button
            title="Edit"
            :image="require('@/images/edit_icon.png')"
            @click="trademarkRedirect()"
          />
        </div>
      </div>
    </VerticalNavigator>
  </scoped>
</template>

<script setup lang="ts">
  import TrademarkSelector from "@/components/selectors/trademark.vue"
  import Breadcrumb from "@/components/breadcrumb.vue"
  import VerticalNavigator from "@/layouts/vertical_navigator.vue"
  import {ref} from "vue"
  import Button from "@/components/button.vue"
  import TrademarkSummary from "@/components/summaries/trademark.vue"
  import router from "@/router"
  import {Trademark} from "@/endpoints/rutsolve/gql/generated/graphql"
  
  const selectedTrademark = ref<Trademark>(null)
  
  function trademarkRedirect() {
    router.push({
      name: "edit_trademark",
      params: {
        trademarkID: selectedTrademark.value.id
      }
    })
  }
</script>

<style scoped>
  .grid {
    display: grid;
    grid-template-areas: "list summary";
    grid-template-columns: auto 1fr;
  
    .list {
      grid-area: list;
      margin: 0 1em 1em 0;
    }
  
    .summary {
      grid-area: summary;
    }
  }
</style>
